import axios from 'axios'
// Mutation types
const SET_EXECUTIONS = 'SET_EXECUTIONS'
const SET_EXECUTION_LOGS = 'SET_EXECUTION_LOGS'
const RESET = 'RESET'

// API Endpoints
const QUERY_ELASTICSEARCH_URL = 'api/ServiceRegistry/queryElasticSearch'
const GET_SERVICE_EXECUTIONS_URL = 'api/ServiceRegistry/GetAllExecutions'
const GET_EXECUTION_LOGS_URL = (processInstanceId, fileId) => 
  `api/ServiceRegistry/GetExecutionLogs?processInstanceId=${processInstanceId}&fileId=${fileId}`

let initialState = () => ({
  logs: [],
  executions: [],
  executionLogs: [],
})

export default {
  namespaced: true,
  state: initialState,
  actions: {
    queryElasticSearch({ commit }, query) {
      return new Promise((resolve, reject) => {
        axios.post(QUERY_ELASTICSEARCH_URL, query, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(function(response) {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchServicesExecutions({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(GET_SERVICE_EXECUTIONS_URL)
          .then(function (response) {
            commit(SET_EXECUTIONS, response.data)
            resolve()
          })
          .catch(error => {
            console.error(error)
            reject(error)
          })
      })
    },
    async fetchExecutionLogs({ commit }, { executionId }) {
      return axios.get(GET_EXECUTION_LOGS_URL(executionId))
        .then(function (response) {
          commit(SET_EXECUTION_LOGS, response.data)
          return response.data
        })
        .catch(error => {
          console.error(error)
          throw error
        })
    },
  },
  mutations: {
    [SET_EXECUTIONS](state, executions) {
      state.executions = executions
    },
    [SET_EXECUTION_LOGS](state, executionLogs) {
      state.executionLogs = executionLogs
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {
    executions: state => state.executions,
    executionLogs: state => state.executionLogs,
  },
}
